import { render, staticRenderFns } from "./LoginQR.vue?vue&type=template&id=2c35bc66&scoped=true&"
import script from "./LoginQR.vue?vue&type=script&lang=js&"
export * from "./LoginQR.vue?vue&type=script&lang=js&"
import style0 from "./LoginQR.vue?vue&type=style&index=0&id=2c35bc66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c35bc66",
  null
  
)

export default component.exports